import TemplateRelatorioModel from "@/models/templateRelatorioModel";
import nfetch from "@/utils/events/nfetch";

class TemplateRelatorioService {
    private controllerName = "TemplateRelatorio";

    public async getTemplates(relatorioId: number) {
        return await nfetch(`/${this.controllerName}/GetTemplates?relatorioId=${relatorioId}`, {
            credentials: "same-origin",
        })
            .withLoading()
            .resolveWithJSON<Array<TemplateRelatorioModel>>();
    }

    public async insert(model: TemplateRelatorioModel): Promise<Response> {
        return await nfetch(`/${this.controllerName}/Insert`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(model),
        }).withLoading();
    }

    public async delete(id: string) {
        return await nfetch(`/${this.controllerName}/Delete?id=${id}`, {
            method: "post",
            credentials: "same-origin",
        }).withLoading();
    }
}

export default new TemplateRelatorioService();
